import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export type CurrencyPageStore = UseBoundStore<StoreApi<ICurrencySlice>>;

export interface ICurrencySlice {
  currencySelectDisabled: boolean;
}

export const createCurrencySliceDefaultValues = (): ICurrencySlice => ({
  currencySelectDisabled: false,
});

export const createCurrencySlice: StateCreator<ICurrencySlice> = () => createCurrencySliceDefaultValues();

export const createCurrencyHooks = (pageStore: CurrencyPageStore) => ({
  useDisabled: () => pageStore((state) => state.currencySelectDisabled),
});

export type CurrencyHooks = ReturnType<typeof createCurrencyHooks>;
